import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { ForBrands } from './pages/ForBrands';
import { ForMarketingAgencies } from './pages/ForMarketingAgencies';
import { ForTalent } from './pages/ForTalent';
import { CaseStudies } from './pages/CaseStudies';
import { CaseStudyDetail } from './pages/CaseStudyDetail';
import { Resources } from './pages/Resources';
import { GuideDetail } from './pages/GuideDetail';
import { Pricing } from './pages/Pricing';
import { Login } from './pages/Login';
import { TermsOfService } from './pages/TermsOfService';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { CookiePolicy } from './pages/CookiePolicy';
const ScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3ij66mgga9xb1">
      <ScrollToTop data-id="element-1" data-mp="3ijpe138b53at" />
      <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-zano-pink/20" data-id="element-2" data-mp="3ii4q3wgi0ilx">
        <Navbar data-id="element-3" data-mp="3mj6j3vjtnyfg" />
        <main data-id="element-4" data-mp="3rcj7c4kla37o">
          <Routes data-id="element-5" data-mp="3rbzmaezn6ypf">
            <Route path="/" element={<Home data-id="element-7" data-mp="3rd189ei755lx" />} data-id="element-6" data-mp="3rdkie91luppe" />
            <Route path="/for-brands" element={<ForBrands data-id="element-9" data-mp="682dxcgkib2" />} data-id="element-8" data-mp="5yj0slx59ec" />
            <Route path="/for-marketing-agencies" element={<ForMarketingAgencies data-id="element-11" data-mp="2zm4zaoz9bl3x" />} data-id="element-10" data-mp="5gbv0xpxarn" />
            <Route path="/list-your-roster" element={<ForTalent data-id="element-13" data-mp="33lx0ggmbmoz9" />} data-id="element-12" data-mp="2zng2amkvootz" />
            <Route path="/for-talent" element={<Navigate to="/list-your-roster" replace data-id="element-15" data-mp="38li9jjv7gdpp" />} data-id="element-14" data-mp="33n6wz1dizp3s" />
            <Route path="/case-studies" element={<CaseStudies data-id="element-17" data-mp="3dl4k1ljnffut" />} data-id="element-16" data-mp="3dkuufz2inapn" />
            <Route path="/case-studies/:slug" element={<CaseStudyDetail data-id="element-19" data-mp="nvsub5qlapwh" />} data-id="element-18" data-mp="3dm5z013scmht" />
            <Route path="/resources" element={<Resources data-id="element-21" data-mp="nxn4bp0boxls" />} data-id="element-20" data-mp="nur7k407oeyx" />
            <Route path="/resources/:slug" element={<GuideDetail data-id="element-23" data-mp="stc7e2bjwwmu" />} data-id="element-22" data-mp="sudmchvou39u" />
            <Route path="/pricing" element={<Pricing data-id="element-25" data-mp="3688dot76uy6" />} data-id="element-24" data-mp="swqbpg3rzfwx" />
            <Route path="/login" element={<Login data-id="element-27" data-mp="34ncnvv5d5yq" />} data-id="element-26" data-mp="35gnb7x88fm5" />
            <Route path="/terms-of-service" element={<TermsOfService data-id="element-29" data-mp="3ubrgkhvzwc2x" />} data-id="element-28" data-mp="3uct4hmy40t22" />
            <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-31" data-mp="d4e5lt427cwp" />} data-id="element-30" data-mp="3ucj91juaptoz" />
            <Route path="/cookie-policy" element={<CookiePolicy data-id="element-33" data-mp="d2l6cyvrzuyq" />} data-id="element-32" data-mp="d3cujon1mqez" />
          </Routes>
        </main>
        <Footer data-id="element-34" data-mp="86w58r43y60b" />
      </div>
    </BrowserRouter>;
}